module.exports = __webpack_public_path__ + "static/media/MHei-Medium.3267b64c.svg";